import { createHttpClient } from '@adapters/HttpClient';
import { useSmartRetry } from '@shared/hooks/useSmartRetry';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { EntryApiAdapter } from '../../adapters';

// Instancias singleton
const httpClient = createHttpClient(apiClientWH);
const entryApiAdapter = new EntryApiAdapter(httpClient);

interface UseEntryDataProps {
  /** ID de la entrada a cargar */
  entryId: number;
  /** Si debe ejecutar la consulta */
  enabled?: boolean;
}

/**
 * Hook para cargar los datos de una entrada específica
 */
export const useEntryData = ({ entryId, enabled = true }: UseEntryDataProps) => {
  // Hook para retry inteligente - no reintenta en 404
  const smartRetry = useSmartRetry({
    maxRetries: 2,
    skipRetryCodes: [404], // Nunca reintentar en 404
  });

  return useQuery({
    queryKey: ['entry', entryId],
    queryFn: () => entryApiAdapter.getEntry(entryId),
    enabled: enabled && !!entryId && entryId > 0,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: smartRetry,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
